import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const branchSalesWidget: DashboardWidgetConfiguration = {
  widgetId: "branch.sales",
  name: "Branch sales",
  description: "Branch sales for the selected dashboard period.",
  apps: [
    "configuration",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "sales.analysis",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "revenue",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Sales",
    subtext: "in the last 30 days",
    icon: "money",
    color: "success",
    valueFormat: "currency",
    valueMultiplier: 1,
  },
  dummyData: {
    value: "0",
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
